module.exports = __webpack_public_path__ + "static/media/sair.e2e6b5f2.svg";